import React from 'react';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import type { IComponentPreviewWrapper } from '@wix/editor-elements-types/thunderboltPreview';
import type { SubmenuProps } from '../types';
import { useMenuPreviewContext } from '../../Menu/viewer/MenuPreviewContext';
import { prefixes } from '../../Menu/skinParams/common';

export const getPartToPreviewStateMap = (
  designPanelPreviewStateMap?: Record<string, string>,
): Record<string, string> => {
  const { selectedPartId, selectedStateId, hoveredStateId } =
    designPanelPreviewStateMap ?? {};
  if (
    !selectedPartId ||
    !selectedStateId ||
    !selectedPartId.startsWith(prefixes.dropdownMenu)
  ) {
    return {};
  }
  const stateToPreview = hoveredStateId ?? selectedStateId;

  return {
    [selectedPartId.replace(`${prefixes.dropdownMenu}-`, '')]: stateToPreview,
  };
};

function withComponentPreview(
  WrappedComponent: React.ComponentType<SubmenuProps>,
): IComponentPreviewWrapper<SubmenuProps, { isComponentDetached: boolean }> {
  return ({
    previewWrapperProps = {},
    partToPreviewStateMap,
    ...viewerProps
  }) => {
    const { designPanelPreviewStateMap } = useMenuPreviewContext();
    const menuPartToPreviewStateMap = getPartToPreviewStateMap(
      designPanelPreviewStateMap,
    );
    const { isComponentDetached } = previewWrapperProps;

    return (
      <WrappedComponent
        {...viewerProps}
        partToPreviewStateMap={{
          ...partToPreviewStateMap,
          ...(!isComponentDetached && menuPartToPreviewStateMap),
        }}
      />
    );
  };
}

export default (ViewerComponent: React.ComponentType<SubmenuProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent));
